import { tabAccessControl } from "../../../_helpers/access-control";

let PricingTabs = [
  {
    text: "Price Groups",
    path: `/price-group`,
    applicationFeatureCode: "PriceGroup",
  },
  {
    text: "Item Price Update",
    path: `/item-price-update`,
    applicationFeatureCode: "ItemPriceUpdate",
  },
  {
    text: "Sell Price by Product",
    path: `/sell-price-product`,
    applicationFeatureCode: "SellPricesbyProduct",
  },
];


function GetIndexByTabName(tabName) {
  return tabAccessControl(PricingTabs).findIndex((x) => x.text == tabName);
}

export { PricingTabs, GetIndexByTabName };